import { createFileRoute, redirect, useLoaderData } from '@tanstack/react-router';
import { Navbar } from '@/components/ui/navbar';
import { CreateEventWizard } from '@/components/createEvent';
import { requireAuthBeforeLoad } from '@/helpers/requireAuthBeforeLoad';
import { checkUserHasOrganizer } from '@/server/organizer';

export const Route = createFileRoute('/create-event')({
  beforeLoad: async ({ context, location }) => {
    const profile = requireAuthBeforeLoad({ context, location });

    if (profile.level !== 'superadmin') {
      const { hasOrganizer } = await checkUserHasOrganizer();
      if (!hasOrganizer) {
        throw redirect({
          to: '/create-organizer',
          search: { redirect: location.href },
        });
      }
    }

    return { isSuperAdmin: profile.level === 'superadmin' };
  },
  loader: ({ context }) => ({ isSuperAdmin: context.isSuperAdmin }),
  component: CreateEventPage,
});

function CreateEventPage() {
  const { isSuperAdmin } = useLoaderData({ from: '/create-event' });

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="container mx-auto px-4 py-8 md:py-12">
        <CreateEventWizard isSuperAdmin={isSuperAdmin} />
      </main>
    </div>
  );
}
